// AddressGeneralInformations.jsx
import { useTranslation } from "react-i18next";
import { Label, Input, FormGroup } from "reactstrap";
import OpeningHoursEditor from "./OpeningHoursEditor";

const AddressGeneralInformations = ({
  editFormData,
  setEditFormData,
  handleFormChange,
  errorForm,
}) => {
  const { t } = useTranslation();

  return (
    <section>
      <section className={`error-form ${errorForm ? "display-error" : ""}`}>
        <p>{errorForm}</p>
      </section>

      <article className="information-bloc">
        <FormGroup className="information-line">
          <Label className="information-label">{t("Name")}</Label>
          <Input
            className="information-column-data"
            type="text"
            required="required"
            placeholder={t("Name")}
            value={editFormData.name}
            onChange={(event) =>
              handleFormChange(event, editFormData, setEditFormData)
            }
            name="name"
          />
        </FormGroup>

        <FormGroup className="information-line">
          <Label className="information-label">{t("Role")}</Label>
          <select
            type="select"
            value={editFormData.role}
            onChange={(event) =>
              handleFormChange(event, editFormData, setEditFormData)
            }
            name="role"
          >
            <option value="sorting_plant">{t("Sorting plant")}</option>
            <option value="client">{t("Client")}</option>
            <option value="building_site">{t("Building site")}</option>
            <option value="dump">{t("Dump")}</option>
            <option value="industrial_site">{t("Industrial site")}</option>
            <option value="landfill_site">{t("Landfill site")}</option>
            <option value="incineration_centre">
              {t("Incineration centre")}
            </option>
            <option value="engineering_consultancy">
              {t("Engineering consultancy")}
            </option>
          </select>
        </FormGroup>
      </article>

      {/* Horaires */}
      <article className="information-bloc">
        <h3>{t("Opening hours")}</h3>
        <OpeningHoursEditor
          value={editFormData.openingLocal}
          timezone={editFormData.openingTimezone || "Europe/Paris"}
          onChange={({ openingLocal, timezone }) =>
            setEditFormData((prev) => ({
              ...prev,
              openingLocal,
              openingTimezone: timezone,
            }))
          }
        />
      </article>
    </section>
  );
};

export default AddressGeneralInformations;
